import Vue from 'vue'
import Router from 'vue-router'

import Home from '@/pages/Home'
import About from '@/pages/About'
import Contact from '@/pages/Contact'
import Products from '@/pages/Products'
import Part from '@/pages/Part'
import Releases from '@/pages/Releases'
import Tips from '@/pages/Tips'
import Events from '@/pages/Events'
import Car from '@/pages/Car'
import ResponsibleDisposal from '@/pages/ResponsibleDisposal.vue'

import VueMask from 'v-mask'
import VueTheMask from 'vue-the-mask'

const VueScrollTo = require('vue-scrollto')

Vue.use(VueTheMask)
Vue.use(VueScrollTo)
Vue.use(Router)
Vue.use(VueMask)

export default new Router({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      component: Home,
      name: 'Home'
    },
    {
      path: '/sobre',
      component: About,
      name: 'About'
    },
    {
      path: '/contato',
      component: Contact,
      name: 'Contact'
    },
    {
      path: '/dicas',
      component: Tips,
      name: 'Tips'
    },
    {
      path: '/lancamentos',
      component: Releases,
      name: 'Releases'
    },
    {
      path: '/produtos',
      component: Products,
      name: 'Products'
    },
    {
      path: '/produto/:code',
      component: Part,
      name: 'Part'
    },
    {
      path: '/eventos',
      component: Events,
      name: 'Events'
    },
    {
      path: '/carro/:id',
      component: Car,
      name: 'Car'
    },
    {
      path: '/descarte-responsavel',
      component: ResponsibleDisposal,
      name: 'ResponsibleDisposal'
    }
    // {
    //   path: '/*',
    //   component: NotFound
    // }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js